/* collection list if list tag is empty */
let lists = document.querySelectorAll('.facets__item')
lists.forEach(list => {
  if(list.firstElementChild === null) {
    list.style.display = 'none';
  }
})

/* collection radio buttons */
document.addEventListener('DOMContentLoaded', colors)
function colors() {
  document.addEventListener('click', changeFrameColorHandler)
}

function changeFrameColorHandler(e) {
  let inputBtn = e.target.previousElementSibling
  if(inputBtn) {
    if(inputBtn.classList.contains('radio-color')) {
      e.preventDefault()
      let frameToUpdate = e.target.parentElement.parentElement.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.firstElementChild
      let cardContent = e.target.parentElement.parentElement.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.lastElementChild
      let newFrame = e.target.parentElement.parentElement.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild // position where we will append our newly created card__media "prepend not append"
      let frameImage = e.target.parentElement.parentElement.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.firstElementChild.lastElementChild
      let productURL = e.target.parentElement.parentElement.previousElementSibling.previousElementSibling.firstElementChild.firstElementChild.firstElementChild.firstElementChild
  
      productURL.style.cssText = `position: absolute; width: 100%; height: 100%; left:0; top:0; z-index: 15;`
   
      let whiteHoz = 'https://cdn.shopify.com/s/files/1/0720/1236/6127/t/20/assets/frame_white_horisontal-n.webp?v=1700831077'
      let blackHoz = 'https://cdn.shopify.com/s/files/1/0720/1236/6127/t/20/assets/frame_black_horisontal-n.webp?v=1700831050'
      let whiteVer = 'https://cdn.shopify.com/s/files/1/0720/1236/6127/t/20/assets/frame_white_verticall-n.webp?v=1700831087'
      let blackVer = 'https://cdn.shopify.com/s/files/1/0720/1236/6127/t/20/assets/frame_black_vertical-n.webp?v=1700831069'
      
      let frameType = e.target.parentElement.parentElement.previousElementSibling.previousElementSibling.firstElementChild.classList.contains('vertical') ? 'vertical' : 'horizontal'
      let frameColor = inputBtn.value.toLowerCase()
    
      let css = ``
      let head = document.head
      let pseudoId = frameToUpdate.getAttribute('id')
      let newCardMedia = document.createElement('div')
      newCardMedia.classList.add('card__media')
      newCardMedia.setAttribute('id', frameToUpdate.getAttribute('id'))
      
      // console.log(frameToUpdate)
      // console.log('type: ', frameType)
      // console.log('color: ', frameColor)
      // console.log('id', pseudoId)
      
      if(frameType === 'vertical') {
        if(frameColor === 'black') {
          css = `#ProductGridContainer .vertical .card__inner #${pseudoId}.card__media::before {background-image: url('${blackVer}')!important}`
          // frameToUpdate.style.setProperty('--black-ver', `url('${blackVer}')!important`)
        } else {
          css = `#ProductGridContainer .vertical .card__inner #${pseudoId}.card__media::before {background-image: url('${whiteVer}')!important}`
          // frameToUpdate.style.setProperty('--white-ver', `url('${whiteVer}')!important`)
        }
      } else {
        if (frameColor === 'black') {
          css = `#ProductGridContainer .horizontal .card__inner #${pseudoId}.card__media::before {background-image: url('${blackHoz}')!important}`
          // frameToUpdate.style.setProperty('--black-hoz', `url('${blackHoz}')!important`)
        } else {
          css = `#ProductGridContainer .horizontal .card__inner #${pseudoId}.card__media::before {background-image: url('${whiteHoz}')!important}`
          // frameToUpdate.style.setProperty('--white-hoz', `url('${whiteHoz}')!important`)
        }
      }
    
      let style = document.createElement('style')
      style.type = 'text/css';
      if (style.styleSheet){
        // This is required for IE8 and below.
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      
      // console.log('style', style)
    
      head.appendChild(style);
      newFrame.innerHTML = ''
      // newCardMedia.appendChild(style)
      newCardMedia.appendChild(productURL)
      newCardMedia.appendChild(frameImage)
      newFrame.appendChild(newCardMedia)
      newFrame.appendChild(cardContent)
      console.log(newCardMedia)   
    }
  }
}